import React from 'react';
import { connect } from 'react-redux';
import { downloadFile } from '../../../actions/data-import';

class CsvTableRow extends React.Component {
  constructor(props) {
    super(props);

    const { checked } = props;

    this.state = {
      checked
    };
  }

  toggleCheck(event) {
    const { handleListChange, filename } = this.props;
    const { checked } = this.state;

    event.stopPropagation();
    handleListChange(filename, !checked ? 'add' : 'remove');
    this.setState({ checked: !checked });
  }

  handleCheckboxClick = event => this.toggleCheck(event);

  handleDownloadLink = () => {
    const { filename, dispatch } = this.props;

    dispatch(downloadFile(filename));
  };

  render() {
    const { filename } = this.props;
    const { checked } = this.state;

    return (
      <tr>
        <td onClick={this.handleCheckboxClick}>
          <input checked={checked} onClick={this.handleCheckboxClick} type="checkbox"/>
        </td>
        <td>
          <a href="#" onClick={this.handleDownloadLink}>
            {filename}
          </a>
        </td>
      </tr>
    );
  }
}

export default connect(null)(CsvTableRow);



// WEBPACK FOOTER //
// ./src/components/admin/data-import/csv-table-row.jsx